import { NewsActions, NewsCreateRequest } from "../domain/news";
import { createNewsService } from "../infrastructure/services/createNewsService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const createNews = {
  async execute(title: string, body: string, image1: File): Promise<void> {
    const request: NewsCreateRequest = await NewsActions().createNewsRequest(
      title,
      body,
      image1
    );
    await createNewsService.execute(await tokenValidation.execute(), request);
  },
};
